<template>
  <div class="patientDetail">
    <PatientDetail backRoute="NursePatient" @viewPatientFiles="viewPatientFiles" />
    <PatientTreatmentList treatmentHistoryDetailRoute="NursePatientTreatmentDetail" />
  </div>
</template>

<script>
import PatientDetail from '@/views/components/patients/Detail';
import PatientTreatmentList from '@/views/components/patients/NursePatientTreatmentList';

export default {
  components: {
    PatientDetail,
    PatientTreatmentList,
  },
  methods: {
    viewPatientFiles(id) {
      this.$router.push({
        name: 'NursePatientFiles',
        params: { patientId: id },
      });
    },
  },
};
</script>
